var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-select',{attrs:{"items":_vm.quotaTimes,"item-value":"value","item-text":"text","label":_vm.$t('transportationPermission.quotaTime', 'Quota timeframe'),"disabled":_vm.disabled},model:{value:(_vm.selectedQuotaTime),callback:function ($$v) {_vm.selectedQuotaTime=$$v},expression:"selectedQuotaTime"}})
}
var staticRenderFns = []

export { render, staticRenderFns }